/**
 * @module Permutation
 */
export default function permutation2(fn, shouldCurry) {
    return (...args) => {
        const [a1, b] = args;
        return (shouldCurry ? shouldCurry?.(a1, b) : args.length < fn.length)
            ? (a2) => fn(a2, a1)
            : fn(a1, b);
    };
}
